<div *ngIf="showTenantSelector" class="dev-tenant-switcher">
  <div *ngIf="loadingTenants" class="dev-dropdown-loading">
    <i class="pi pi-spin pi-spinner"></i>
  </div>
  <p-select
    *ngIf="!loadingTenants"
    [options]="availableTenants"
    [(ngModel)]="selectedTenant"
    optionLabel="label"
    optionValue="value"
    (onChange)="changeTenant($event.value)"
    placeholder="Select Tenant"
    class="dev-dropdown"
    [filter]="availableTenants.length > 8"
  ></p-select>
</div>

<app-auth-layout
  pageTitle="Welcome back"
  subtitle="Don't have an account?"
  actionLinkText="Sign up"
  actionLinkRoute="/register"
>
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
    <button
      type="button"
      (click)="microsoftLogin()"
      class="flex items-center justify-center gap-3 px-4 py-2.5 h-11 border border-gray-200 rounded-lg hover:bg-gray-50 hover:border-gray-300 transition-all text-sm font-semibold text-gray-700 bg-white group relative overflow-hidden"
    >
      <i
        class="pi pi-microsoft text-xl group-hover:text-[#00a4ef] transition-colors"
      ></i>
      <span>Microsoft</span>
    </button>

    <div class="relative group">
      <button
        type="button"
        class="flex items-center justify-center gap-3 px-4 py-2.5 h-11 w-full border border-gray-200 rounded-lg group-hover:bg-gray-50 group-hover:border-gray-300 transition-all text-sm font-semibold text-gray-700 bg-white"
      >
        <i
          class="pi pi-google text-xl text-gray-500 group-hover:text-[#DB4437] transition-colors"
        ></i>
        <span>Google</span>
      </button>

      <div
        class="absolute inset-0 z-10 opacity-0 overflow-hidden flex justify-center items-center"
      >
        <asl-google-signin-button type="standard" size="large" width="400">
        </asl-google-signin-button>
      </div>
    </div>
  </div>

  <div class="relative mb-8">
    <div class="absolute inset-0 flex items-center">
      <div class="w-full border-t border-gray-200"></div>
    </div>
    <div class="relative flex justify-center text-xs uppercase tracking-wider">
      <span class="px-4 bg-white text-gray-400 font-semibold"
        >Or login with</span
      >
    </div>
  </div>

  <form
    (ngSubmit)="onSubmit()"
    #loginForm="ngForm"
    novalidate
    class="space-y-5"
  >
    <div class="flex flex-col gap-1.5">
      <label for="email" class="text-sm font-semibold text-gray-700 ml-1"
        >Email Address</label
      >
      <input
        pInputText
        id="email"
        type="email"
        name="email"
        [(ngModel)]="model.email"
        class="w-full h-11 px-4 !bg-gray-50 border border-gray-200 focus:!bg-white focus:!border-[--primary-500] focus:ring-4 focus:ring-[--primary-100] outline-none text-sm transition-all rounded-lg"
        placeholder="Enter your email"
        required
      />
    </div>

    <div class="flex flex-col gap-1.5">
      <div class="flex justify-between items-center ml-1">
        <label for="password" class="text-sm font-semibold text-gray-700"
          >Password</label
        >
        <a
          [routerLink]="['/forgotpassword']"
          class="text-xs font-semibold text-[--primary-500] hover:text-[--primary-700] hover:underline cursor-pointer"
        >
          Forgot password?
        </a>
      </div>
      <div class="relative">
        <input
          pInputText
          id="password"
          [type]="showPassword ? 'text' : 'password'"
          name="password"
          [(ngModel)]="model.password"
          class="w-full h-11 px-4 pr-11 !bg-gray-50 border border-gray-200 focus:!bg-white focus:!border-[--primary-500] focus:ring-4 focus:ring-[--primary-100] outline-none text-sm transition-all rounded-lg"
          placeholder="Enter your password"
          required
        />
        <button
          type="button"
          (click)="showPassword = !showPassword"
          tabindex="-1"
          class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <i
            class="pi"
            [ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'"
          ></i>
        </button>
      </div>
    </div>

    <div class="flex items-center gap-2 pt-1">
      <p-checkbox
        inputId="rememberMe"
        name="rememberMe"
        [binary]="true"
        [(ngModel)]="rememberMe"
        styleClass="checkbox-small"
      ></p-checkbox>
      <label
        for="rememberMe"
        class="text-sm text-gray-600 cursor-pointer select-none"
        >Keep me logged in</label
      >
    </div>

    <button
      pButton
      type="submit"
      [label]="submitting ? 'Signing In...' : 'Sign In'"
      class="w-full h-11 font-bold text-base bg-[--primary-500] text-white border-none hover:bg-[--primary-600] active:scale-[0.98] transition-all rounded-lg shadow-lg shadow-blue-500/20 mt-2"
      [loading]="submitting"
      [disabled]="loginForm.invalid"
    ></button>
  </form>
</app-auth-layout>
